<template>
  <div>
    <tasks-template ref="tasks" tool="publisher"> </tasks-template>
    <floating-repair-select @open="openChatBox" />
  </div>
</template>

<script>
import TaskTemplate from '../ToolsTemplates/TaskPage';
import FloatingRepairSelect from '../Shared/FloatingRepairSelect';
import WorkOrderListStrategy from '../ChatBox/strategies/WorkOrderListStrategy';
import store from '../../store/index';
import JobViewMixin from '../../mixins/Shared/JobViewMixin';

export default {
  components: {
    'tasks-template': TaskTemplate,
    FloatingRepairSelect,
  },
  mixins: [JobViewMixin],
  async beforeRouteEnter(to, from, next) {
    const { id } = to.params;
    try {
      if (!store.state.job || store.state.job.id !== id) {
        await store.dispatch('getJob', id);
      }
      next();
    } catch (error) {
      console.error('Failed to fetch job:', error);
      // Optionally redirect here yourself or just call next()
      next();
    }
  },
  methods: {
    openChatBox() {
      this.$chatbox.open({
        strategy: new WorkOrderListStrategy(),
      });
    },
  },
};
</script>

<style></style>
